<ng-container [ngSwitch]="searchFilter.type">
	<span *ngSwitchCase="'firmreference'" [ngbTooltip]="expand ? null : firmReference">
		<i *ngIf="expand" nstarIcon>firm</i> {{ searchFilter.name }}
		<span class="badge badge-primary text-light" *ngIf="expand">{{ searchFilter.value }}</span>
	</span>
	<span *ngSwitchCase="'officereference'" [ngbTooltip]="expand ? null : officeReference">
		<i *ngIf="expand" nstarIcon>office</i> {{ searchFilter.name }}
		<span class="badge badge-primary text-light" *ngIf="expand">{{ searchFilter.value }}</span>
	</span>
	<span *ngSwitchCase="'agentreference'" [ngbTooltip]="expand ? null : agentReference">
		<i *ngIf="expand" nstarIcon>agent</i> {{ searchFilter.name }}
		<span class="badge badge-primary text-light" *ngIf="expand">{{ searchFilter.value }}</span>
	</span>
	<ng-container *ngSwitchDefault>
		{{ searchFilter.name }}
	</ng-container>
</ng-container>
<ng-template #firmReference> <i nstarIcon>firm</i> {{ searchFilter.value }} </ng-template>
<ng-template #officeReference> <i nstarIcon>office</i> {{ searchFilter.value }} </ng-template>
<ng-template #agentReference> <i nstarIcon>agent</i> {{ searchFilter.value }} </ng-template>
